







import Vue from 'vue';
export default Vue.extend({
  name: 'FullscreenLoading',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
});
